import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import { useSelector } from "react-redux";
import { getBillingProfile, getFacilityInfo, getPurchaseData, } from "../../../../Store/purchase.slice";
import Typography from "@material-ui/core/Typography";
import { useHistory } from "react-router";
import ReactMarkdown from "react-markdown";
import { get, isEmpty } from "lodash";
import * as moment from "moment";
import accessDeviceTypes from "../../Common/accessDeviceTypes";
import Box from "@material-ui/core/Box";
import { toDollars } from "../../utils";
import { ratesMap } from "../../../../Store/rates.slice";
import Button from "@material-ui/core/Button";
import { formatPhoneNumber } from "../../../../Entities/util";
import Link from "@material-ui/core/Link";
import { useTheme } from "@material-ui/core";

export function ConfirmPage() {
    const theme = useTheme();
    const history = useHistory();
    const { subscription } = useSelector(getPurchaseData);
    const { next_steps, secondMonthPayment } = useSelector(getBillingProfile);
    const { facility_name } = useSelector(getFacilityInfo);
    const rates = useSelector(ratesMap);
    const payor = get(subscription, 'payor', {});
    const parkers = get(subscription, 'parkers', []);
    let invoices = get(subscription, 'invoices', [])
    if (!secondMonthPayment){
        invoices.filter(({ type }) => type === 'FIRST_MONTH_INVOICE');
    }
    const startDates = parkers.map((parker) => {
        return parker.parker_status_history.find(({ action }) => action === 'PARKER_START_DATE').start_date;
    });
    
    useEffect(() => {
        if (isEmpty(subscription)) history.push('/');
    }, [subscription, history])

    return <Grid container>
        <Grid item xs={12}><LinearProgress variant="determinate" value={100} /></Grid>
        <Grid container item xs={12} spacing={3}>
            <Grid item xs={12}>
                <Typography variant="h4" align="center">{facility_name} Sign Up Confirmation</Typography>
            </Grid>
            <Grid item xs={12}>
                <Box px={3}><Typography variant="h6">Your sign up is confirmed!</Typography></Box>
            </Grid>
            <Grid item xs={12}><Box px={3}><ReactMarkdown source={next_steps} /></Box></Grid>
            <Grid item xs={12}><Box px={3}><Typography variant="h6">Transaction Details:</Typography></Box></Grid>
            {invoices.map(({ readable_id, created_at, payments }, index) => (<Grid key={index} item xs={12}>
                <Box px={3}>
                    <Typography variant="subtitle1" data-cy="invoice-id-text"><strong>Invoice ID: </strong> {readable_id}</Typography>
                    <Typography variant="subtitle1" data-cy="transaction-date-text">
                        <strong>Transaction Date: </strong>
                        {moment(created_at, 'x').utc().format('LL')}
                    </Typography>
                </Box>
                {payments.map(({ type, amount, payment_meta }, payIndex) => <Box px={3} key={payIndex}>
                    <Typography variant="subtitle1" data-cy="payment-amount-text"><strong>Payment Amount: </strong> {toDollars(amount)}</Typography>
                    <Typography variant="subtitle1" data-cy="payment-method-text">
                        <strong>Payment Method: </strong>
                        {payment_meta.card && `${payment_meta.card.type} ${payment_meta.card.masked_card_number.slice(-4)} ${payment_meta.card.expiry_month}/${payment_meta.card.expiry_year}`}
                        {payment_meta.check && `Bank account ending in ${payment_meta.check.masked_account_number.slice(-4)}`}
                    </Typography>
                </Box>)}

            </Grid>))}
            <Grid item xs={12}><Box px={3}><Typography variant="h6">Primary Contact Information:</Typography></Box></Grid>
            <Grid item xs={12}>
                <Box px={3}>
                    <Typography variant="subtitle1" data-cy="contact-type-text">
                        <strong>Type: </strong> {payor.type === 'INDIVIDUAL' ? 'Individual' : 'Business'}
                    </Typography>
                    <Typography variant="subtitle1" data-cy="contact-name-text">
                        <strong>Name: </strong> {payor.billing_firstname} {payor.billing_lastname}
                    </Typography>
                    <Typography variant="subtitle1" data-cy="contact-email-text"><strong>E-Mail: </strong> {payor.billing_email}</Typography>
                    <Typography variant="subtitle1" data-cy="contact-phone-number-text"><strong>Phone: </strong> {formatPhoneNumber(payor.billing_phone)}</Typography>
                    <Typography variant="subtitle1" data-cy="contact-street-text"><strong>Address: </strong> {payor.billing_street}</Typography>
                    <Typography variant="subtitle1" data-cy="contact-city-state-zip-text">
                        {payor.billing_city}, {payor.billing_state} {payor.billing_zip}
                    </Typography>
                </Box>
            </Grid>
            {payor.info_name &&
                <>
                    <Grid item xs={12}><Box px={3}><Typography variant="h6">Billing Address: </Typography></Box></Grid>
                    <Grid item xs={12}>
                        <Box px={3}>
                            {payor.type === 'BUSINESS' ?
                                <>
                                    <Typography variant="subtitle1" data-cy="business-name-text"><strong>Business Name: </strong>{payor.info_name}</Typography>
                                    <Typography variant="subtitle1" data-cy="business-attention-text"><strong>Attention: </strong>{payor.info_attn}</Typography>
                                    <Typography variant="subtitle1" data-cy="business-street-text"><strong>Address: </strong> {payor.info_street}</Typography>
                                    <Typography variant="subtitle1" data-cy="business-city-state-zip-text">
                                        {payor.info_city}, {payor.info_state} {payor.info_zip}
                                    </Typography>
                                </>
                                :
                                <>
                                    <Typography variant="subtitle1" data-cy="billing-contact-name-text"><strong>Name: </strong>{payor.info_name}</Typography>
                                    <Typography variant="subtitle1" data-cy="billing-contact-street-text"><strong>Address: </strong>{payor.info_street}</Typography>
                                    <Typography variant="subtitle1" data-cy="billing-contact-city-state-zip-text">
                                        {payor.info_city}, {payor.info_state} {payor.info_zip}
                                    </Typography>
                                </>
                            }
                        </Box>
                    </Grid>
                </>
            }
            <Grid item xs={12}><Box px={3}><Typography variant="h6">Parkers:</Typography></Box></Grid>
            {parkers.map(({ id, first_name, last_name, access_devices, parkerRateHistory }, parkerIndex) => (
                <Grid key={parkerIndex} item xs={12}>
                    <Box px={3}>
                        <Typography variant="subtitle1" data-cy={`parker-full-name-text-${parkerIndex}`}><strong>{first_name} {last_name}</strong></Typography>
                        <Typography variant="subtitle1" data-cy={`parker-start-date-text-${parkerIndex}`}>
                            <strong>Start Date: </strong>
                            {moment(startDates[parkerIndex]).utc().format('LL')}
                        </Typography>
                        <Typography variant="subtitle1" data-cy={`parker-product-text-${parkerIndex}`}>
                            <strong>Product: </strong> {parkerRateHistory[0].rate.name}
                        </Typography>
                        <Typography variant="subtitle1"><strong>Access Device(s) Selected:</strong></Typography>
                        {access_devices.map(({ type }, key) => (
                            <Typography key={key} variant="subtitle1" data-cy={`access-device-text-${key}`}>
                                {accessDeviceTypes[type].text}
                                {type === 'BARCODE' && <Link style={{ paddingLeft: theme.spacing(1) }} href={
                                    `/account/monthly/parkers?subscription=${subscription.id}&parker=${id}&barcode=true`
                                } target="_blank" rel="noopener" data-cy={`access-device-view-link-${key}`}>View Code</Link>}
                            </Typography>
                        ))}
                    </Box>
                </Grid>
            ))}
        </Grid>
    </Grid >
}

export default React.memo(ConfirmPage);
